export * from './types';
export * from './user';
export * from './learningObject';

import axios, { type AxiosInstance } from 'axios';
import { AuthService, PrimeLearningObjectEndpoint } from '@/services';
import type { IAuthData } from '@/services/auth/types';
import { PrimeUserEndpoint } from '@/services/prime/user';

export class PrimeService {
  axios: AxiosInstance;

  user: PrimeUserEndpoint;
  learningObject: PrimeLearningObjectEndpoint;

  constructor(authService: AuthService) {
    this.axios = axios.create({
      baseURL: `${authService.config.NV_BASE_PRIME_API}primeapi/v2/`,
      headers: {
        Accept: 'application/vnd.api+json;charset=UTF-8'
      }
    });

    this.user = new PrimeUserEndpoint(this.axios);
    this.learningObject = new PrimeLearningObjectEndpoint(this.axios, authService.config);
  }

  async init(auth: IAuthData) {
    this.axios.defaults.headers.Authorization = 'oauth ' + auth.access_token;
  }

  locale(locale: string) {
    this.learningObject.locale(locale);
  }
}
